import { useFlags } from 'launchdarkly-react-client-sdk'
import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'

import { NOTIFICATION_APP_ID } from '@/constants/common'
import {
  setNotificationAppId,
  setUserInteracted,
  updateFlags
} from '@/ducks/app/slices/app.slice'

function generateUniqueId() {
  return Math.random().toString(36).slice(2, 11)
}
import { startInitialization } from '@/ducks/app/slices/app.shared'

import { blurHandler, focusHandler, visibilityChangeHandler } from './helpers'

const Initializer = React.memo(() => {
  const dispatch = useDispatch()
  const flags = useFlags()

  const requestNotificationPermission = () => {
    if (typeof window !== 'undefined' && 'Notification' in window) {
      Notification.requestPermission()
    }
  }
  useEffect(() => {
    requestNotificationPermission()
    visibilityChangeHandler()

    document.addEventListener('visibilitychange', visibilityChangeHandler)
    window.addEventListener('focus', focusHandler)
    window.addEventListener('blur', blurHandler)

    return () => {
      document.removeEventListener('visibilitychange', visibilityChangeHandler)
      window.removeEventListener('focus', focusHandler)
      window.removeEventListener('blur', blurHandler)
    }
  }, [])

  useEffect(() => {
    dispatch(startInitialization())
    dispatch(updateFlags(flags))
  }, [dispatch, flags])

  useEffect(() => {
    const uniqueId = generateUniqueId()
    dispatch(setNotificationAppId({ id: uniqueId }))
    localStorage.setItem(NOTIFICATION_APP_ID, uniqueId)

    window.addEventListener('beforeunload', () => {
      localStorage.setItem(NOTIFICATION_APP_ID, '')
    })
  }, [dispatch])
  useEffect(() => {
    const handleUserInteraction = () => {
      dispatch(setUserInteracted())
    }
    window.addEventListener('click', handleUserInteraction)
    window.addEventListener('keydown', handleUserInteraction)
    window.addEventListener('touchstart', handleUserInteraction)
    return () => {
      window.removeEventListener('click', handleUserInteraction)
      window.removeEventListener('keydown', handleUserInteraction)
      window.removeEventListener('touchstart', handleUserInteraction)
    }
  }, [dispatch])

  return null
})
Initializer.displayName = 'Initializer'

export default Initializer
